import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { createContext, useState } from "react";

export const TagStateContext = createContext();
export const TagStateDispatchContext = createContext();

export const TagProvider = ({ children }) => {
  const { t: trans } = useTranslation();
  const [tag, setTag] = useState(trans("All"));

  return (
    <TagStateContext.Provider value={tag}>
      <TagStateDispatchContext.Provider value={setTag}>
        {children}
      </TagStateDispatchContext.Provider>
    </TagStateContext.Provider>
  );
};

TagProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
